import { AxiosError, AxiosResponse } from "axios";
import ResponseCode from "./ResponseCode";
import ApiResponseStatus, { HttpStatus } from "./ApiResponseStatus";

const extractApiConnectionResponseStatus = (responseOrError: AxiosResponse | AxiosError | undefined): ApiResponseStatus => {
    const response: AxiosResponse | undefined = (responseOrError as AxiosError).response || (responseOrError as AxiosResponse);

    if ((responseOrError as AxiosError)?.message === 'canceled') {
        return {
            status: undefined,
            code: ResponseCode.REQUEST_CANCELED
        }
    }

    if (!response?.status) {
        return {
            status: undefined,
            code: ResponseCode.CONNECTION_ERROR
        }
    }

    return {
        status: response?.status as HttpStatus,
        code: getCode(response)
    }

}
export default extractApiConnectionResponseStatus;


const getCode = (response: AxiosResponse): ResponseCode => {
    const code = extractCodeFromHeaders(response.headers);

    if (code) {
        return code;
    }

    if (response.status >= 500) {
        return ResponseCode.GENERAL_SERVER_ERROR;
    }

    return (response.status + '.00') as unknown as ResponseCode;
}

const extractCodeFromHeaders = (headers: { [headerName: string]: string }): ResponseCode | undefined => {
    const headerValue = headers?.['response-status'] || '';
    const matches = headerValue.match(/^\((\d\d\d\.\d\d)\)/);
    const code = matches && matches[1];

    if (!code) {
        return undefined;
    }
    return code as ResponseCode;
}
